import { useInfiniteQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import {
  getNextPaginationPage,
  composePaginationSchema,
} from "../../../../../../schemas/pagination";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useRefunds = (params, options = {}) => {
  return useInfiniteQuery({
    queryKey: ["refundsReport", params],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await http.get(HTTP_ENDPOINTS.getRefundsReport(), {
        params: {
          ...params,
          pagesize: 15,
          page: pageParam,
        },
      });

      const composeResponse = {
        ...composePaginationSchema({
          response: res?.data?.data || {},
          pageSize: 15,
        }),
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        reportHeader: res.data.data.report_header,
        refundModeLabels: res.data.data.refund_mode_label,
      };
      return composeResponse;
    },
    ...options,
    getNextPageParam: getNextPaginationPage,
  });
};
